import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import {
  ThemeProvider,
  CssBaseline,
  Box,
  Typography,
  Container,
} from "@mui/material";

import theme from "./theme/theme";
import "./App.css";

// Pages
import Home from "./pages/Home";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeleteAccount from "./pages/DeleteAccount";
import Support from "./pages/Support";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box
          sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
        >
          {/* Main content */}
          <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/support" element={<Support />} />
            </Routes>
          </Container>

          {/* Footer */}
          <Box
            component="footer"
            sx={{
              py: 3,
              px: 2,
              mt: "auto",
              backgroundColor: theme.palette.background.paper,
              borderTop: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Container maxWidth="lg">
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  align="center"
                >
                  {new Date().getFullYear()} Blueberrybytes Services FZCO. All
                  rights reserved.
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
                <Link
                  to="/terms"
                  style={{
                    color: theme.palette.text.secondary,
                    textDecoration: "none",
                  }}
                >
                  <Typography variant="body2">Terms of Service</Typography>
                </Link>
                <Link
                  to="/privacy"
                  style={{
                    color: theme.palette.text.secondary,
                    textDecoration: "none",
                  }}
                >
                  <Typography variant="body2">Privacy Policy</Typography>
                </Link>
                <Link
                  to="/support"
                  style={{
                    color: theme.palette.text.secondary,
                    textDecoration: "none",
                  }}
                >
                  <Typography variant="body2">Support</Typography>
                </Link>
              </Box>
            </Container>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
